import { mainApi } from "services/main";
import {
  AgentFileDownloadRequest,
  AgentFileDownloadResponse,
  GetAgentRunHistoryRequest,
  GetAgentRunHistoryResponse,
  GetAgentWorkRequest,
  GetAgentWorkResponse,
  InvokeAgentRequest,
  InvokeAgentResponse,
} from "./definitions";
import { MOCK_RUN_HISTORY } from "./mock-data";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getAgentWork: builder.query<GetAgentWorkResponse, GetAgentWorkRequest>({
      query: ({ auditId, taskId, runId }) => ({
        url: `audit-agent/work/${auditId}/${taskId}`,
        params: { ...(runId ? { runId } : {}) },
      }),
    }),
    invokeAgent: builder.mutation<InvokeAgentResponse, InvokeAgentRequest>({
      query: (body) => ({
        url: "audit-agent/invoke",
        method: "POST",
        body,
      }),
    }),
    agentFileDownloadUrl: builder.query<
      AgentFileDownloadResponse,
      AgentFileDownloadRequest
    >({
      query: ({ s3Key, teamName }) => ({
        url: "agent/download-url",
        params: { s3Key, teamName },
      }),
    }),
    getAgentRunHistory: builder.query<
      GetAgentRunHistoryResponse,
      GetAgentRunHistoryRequest
    >({
      // TODO: Replace queryFn with the real API query once the backend run
      // history operation exists. The request/response shapes are provisional.
      // query: ({ auditId, taskId }) => ({
      //   url: `audit-agent/runs/${auditId}/${taskId}`,
      // }),
      queryFn: (_request) => ({ data: { runs: MOCK_RUN_HISTORY } }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAgentWorkQuery,
  useInvokeAgentMutation,
  useLazyAgentFileDownloadUrlQuery,
  useGetAgentRunHistoryQuery,
} = extendedApi;
